import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { injectIntl } from "react-intl";
import {
    StyleHeading,
    StyleTypography,
    AboutLocationMapContainer,
    StyleInfoTypography,
} from "../../assets/js/Theme";
import SvgIcon from "../../components/SvgIcon";
import { customReplaceAll, toggleText } from "../../resources/utils";
import { DEFAULT_TEXT_LIMIT } from "../../resources/Constants";
import { getProjectData } from "../../crud/avm.crud";
import CustomGoogleMap from "../../components/CustomGoogleMap";
const AboutProperty = (props) => {
    const { intl, overallResults, reportHash } = props;
    // const reportId = overallResults?.reportId || "";
    const [amenities, setAmenities] = useState([]);
    const [locInfo, setLocInfo] = useState();
    const [landmarks, setLandmarks] = useState([]);
    const [showHideText, setShowHideText] = useState(false);

    const _fetchProjectData = async (values) => {
        try {
            const queryParams = {
                locationId: overallResults?.locationId || "",
                // reportId,
                reportHash,
            };
            const result = await getProjectData(queryParams);
            const { status, data } = result.data;
            const { amenities, info, landmarks } = data;
            if (status === 1) {
                setLocInfo(info);
                setAmenities(amenities);
                setLandmarks(landmarks);
            } else {
                console.log("data are not populated");
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        _fetchProjectData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Grid container>
                {locInfo || amenities.length || landmarks.length ? (
                    <Grid item xs={12} className="section--heading--wrapper">
                        <hr />
                        <StyleHeading
                            color="secondary"
                            className="heading--text"
                            variant="h2"
                        >
                            {intl.formatMessage({
                                id: "ABOUT.HEADING.KNOW_MORE_ABOUT",
                            })}
                        </StyleHeading>
                        <hr />
                    </Grid>
                ) : null}
                {locInfo ? (
                    <Grid container className="about--property--wrapper">
                        <Grid
                            item
                            xs={12}
                            md={
                                locInfo?.latitude && locInfo?.longitude ? 7 : 12
                            }
                        >
                            <Grid
                                container
                                spacing={3}
                                className="about--property--text"
                            >
                                <Grid item xs={12}>
                                    <StyleHeading
                                        color="primary"
                                        variant="h2"
                                    >{`${intl.formatMessage({
                                        id: "ABOUT.HEADING.ABOUT_TEXT",
                                    })} ${locInfo?.name}`}</StyleHeading>
                                </Grid>
                                <Grid item xs={12}>
                                    <StyleTypography
                                        color="primary"
                                        gutterBottom
                                    >
                                        {locInfo &&
                                            toggleText(
                                                locInfo?.description_en,
                                                DEFAULT_TEXT_LIMIT,
                                                !showHideText
                                            )}
                                    </StyleTypography>
                                    {locInfo?.description_en.length >
                                    DEFAULT_TEXT_LIMIT ? (
                                        <StyleInfoTypography
                                            component="a"
                                            onClick={() => {
                                                setShowHideText(!showHideText);
                                            }}
                                        >
                                            {showHideText
                                                ? intl.formatMessage({
                                                      id: "GENERAL.VIEW_LESS",
                                                  })
                                                : intl.formatMessage({
                                                      id: "GENERAL.VIEW_MORE",
                                                  })}
                                        </StyleInfoTypography>
                                    ) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                        {locInfo?.latitude && locInfo?.longitude ? (
                            <Grid item xs={12} md={5}>
                                <CustomGoogleMap
                                    mapContainerStyle={
                                        AboutLocationMapContainer
                                    }
                                    coordinates={{
                                        lat: locInfo?.latitude,
                                        lng: locInfo?.longitude,
                                    }}
                                />
                            </Grid>
                        ) : null}
                    </Grid>
                ) : null}
                {amenities.length ? (
                    <Grid container className="amenities--wrapper">
                        <Grid item xs={12}>
                            <StyleHeading
                                color="primary"
                                align="center"
                                variant="h2"
                            >
                                {intl.formatMessage({
                                    id: "ABOUT.HEADING.AMENITIES",
                                })}
                            </StyleHeading>
                        </Grid>
                        <Grid
                            container
                            spacing={3}
                            className="amenities--values--wrapper"
                        >
                            {amenities.map((amenity, index) => (
                                <Grid item xs={6} md={3} key={index}>
                                    <StyleTypography
                                        color="primary"
                                        className="amenity--wrapper"
                                        component="div"
                                    >
                                        <Typography
                                            component="span"
                                            className="icon--wrapper"
                                        >
                                            <SvgIcon
                                                name={customReplaceAll(
                                                    amenity.name.toLowerCase(),
                                                    " ",
                                                    "-"
                                                )}
                                            />
                                        </Typography>
                                        <StyleTypography>
                                            {" "}
                                            {amenity.name}
                                        </StyleTypography>
                                    </StyleTypography>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                ) : null}
                {landmarks.length ? (
                    <Grid container className="nearest--landmark--wrapper">
                        <Grid item xs={12}>
                            <StyleHeading
                                color="primary"
                                align="center"
                                variant="h2"
                            >
                                {intl.formatMessage({
                                    id: "ABOUT.HEADING.NEAREST_LANDMARK",
                                })}
                            </StyleHeading>
                        </Grid>
                        <Grid
                            container
                            spacing={3}
                            className="landmark--values--wrapper"
                        >
                            {landmarks.map((landmark, index) => (
                                <Grid item xs={6} md={3} key={index}>
                                    <StyleTypography
                                        color="primary"
                                        className="landmark--wrapper"
                                        component="div"
                                    >
                                        <div
                                            className={`icon--wrapper ${
                                                landmark.km > 20
                                                    ? "low--opacity"
                                                    : landmark.km > 10
                                                    ? "md--opacity"
                                                    : "full--opacity"
                                            }`}
                                        >
                                            <SvgIcon name="circle" />
                                        </div>
                                        <StyleTypography
                                            color="primary"
                                            component="div"
                                        >
                                            {landmark.name}
                                            <StyleHeading
                                                color="secondary"
                                                className="font-weight-400"
                                                variant="h4"
                                            >
                                                {`${
                                                    landmark.km
                                                } ${intl.formatMessage({
                                                    id: "GENERAL.KM",
                                                })}`}
                                            </StyleHeading>
                                        </StyleTypography>
                                    </StyleTypography>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                ) : null}
            </Grid>
        </>
    );
};

export default injectIntl(AboutProperty);
